<template>
  <div id="app">
    <div id="ap-wrapper">
      <div id="ap-canvas">
        <div id="ap-top-bar">
          <div id="ap-burger">
            <button type="button"></button>
          </div>

          <div class="left">
            <span id="ap-welcome-text">{{ $t('ml_107448', { displayName: user.displayName }) }}</span>

            <a href="https://my.airproducts.com">
              <span class="ap-blue">My</span><span class="ap-my-company">AirProducts</span>
              <span class="ap-service-mark">&#8480;</span>
            </a>

            <ap-link v-if="user.internal" href="https://apdirect.airproducts.com">APDirect</ap-link>

            <a id="osvc_reg_contactus" :href="contactUsUrl">{{ $t('ml_107453') }}</a>

            <a id="osvc_reg_customerSupport" :href="customerSupportUrl">{{ $t('ml_107454') }}</a>
          </div>
          <div class="right">
            <a href="https://www.airproducts.com" id="ap-my-company-website">airproducts.com</a>
          </div>
        </div>

        <div id="ap-mega-menu">
          <div id="ap-logo">
            <a href="https://www.airproducts.com">
              <img src="https://inc.airproducts.com/template/img/ap_logo.png" alt="AirProducts Home" width="206" height="42" />
            </a>
          </div>

          <div id="my-ap">
            <span class="ap-blue">My</span><span class="ap-green ap-my-company">AirProducts</span>
            <span class="ap-green ap-service-mark">&#8480;</span>
          </div>
        </div>

        <div id="ap-flex">
          <div id="ap-side-menu">
            <div id="ap-menu-bar">{{ user.lastName }}, {{ user.firstName }}</div>
            <div id="ap-menu-content">
              <left-nav :revalStatus="revalidationStatus" :items="navItems"></left-nav>
            </div>
          </div>
          <div id="ap-site-content">
            <router-view />
          </div>
        </div>
        <div id="osvc_inlay"></div>
        <div id="ap-footer">
          <div id="ap-footer-links">
            <a
              v-show="
                user.countryCode != 'NL' &&
                  user.countryCode != 'BE' &&
                  user.countryCode != 'FR' &&
                  user.countryCode != 'NL' &&
                  user.countryCode != 'ES' &&
                  user.countryCode != 'PT' &&
                  user.countryCode != 'AR'
              "
              :href="facebookUrl"
            >
              <div class="ap-branding-icon ap-facebook"></div>
              <div class="ap-branding-text">Facebook</div>
            </a>

            <a
              v-show="
                user.countryCode != 'NL' &&
                  user.countryCode != 'BE' &&
                  user.countryCode != 'FR' &&
                  user.countryCode != 'AR' &&
                  user.countryCode != 'BR' &&
                  user.countryCode != 'CO'
              "
              :href="twitterUrl"
            >
              <div class="ap-branding-icon ap-twitter"></div>
              <div class="ap-branding-text">Twitter</div>
            </a>

            <a v-show="user.countryCode != 'EC'" :href="youtubeUrl">
              <div class="ap-branding-icon ap-youtube"></div>
              <div class="ap-branding-text">Youtube</div>
            </a>

            <a v-show="user.countryCode != 'PT'" :href="linkedinUrl">
              <div class="ap-branding-icon ap-linkedin"></div>
              <div class="ap-branding-text">LinkedIn</div>
            </a>

            <a :href="legalnoticeUrl">
              <div class="ap-branding-icon ap-legalnotice"></div>
              <div class="ap-branding-text">{{ $t('ml_113152') }}</div>
            </a>

            <a :href="privacypolicyUrl">
              <div class="ap-branding-icon ap-legalnotice"></div>
              <div class="ap-branding-text">{{ $t('ml_113151') }}</div>
            </a>

            <a
              v-show="user.countryCode == 'AE' || user.countryCode == 'OM'"
              href="https://www.instagram.com/airproductsmiddleeast/"
            >
              <div class="ap-branding-icon"><img src="@/assets/icons/instragram.gif" /></div>
              <div class="ap-branding-text">Instagram</div>
            </a>

            <a v-show="user.countryCode == 'ES'" href="https://www.instagram.com/carburos_metalicos">
              <div class="ap-branding-icon"><img src="@/assets/icons/instragram.gif" /></div>
              <div class="ap-branding-text">Instagram</div>
            </a>
          </div>

          <div id="ap-copyright">Copyright &copy; 1996 – 2018 Air Products and Chemicals, Inc</div>
        </div>

        <div id="ap-menu-overlay"></div>
      </div>
    </div>

    <div id="ap-loading-overlay">
      <div id="ap-loading-image"></div>
    </div>
  </div>
</template>

<style></style>
<script>
import LeftNav from '@/components/LeftNav.vue'
import ApLink from '@/components/APLink.vue'

export default {
  app: 'home',
  components: {
    LeftNav,
    ApLink
  },
  data() {
    return {
      navItems: [],
      contactUsUrl: '',
      facebookUrl: '',
      twitterUrl: '',
      youtubeUrl: '',
      linkedinUrl: '',
      customerSupportUrl: ''
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    revalidationStatus() {
      return this.$store.state.revalidationStatus
    }
  },
  mounted() {
    let self = this
    window.apci.init([
      {
        countries: ['GB'],
        salesOrgs: ['GB46'],
        disable: { favIcon: false, pageTitle: false, logo: false, myText: false, myCompanyWebsite: false, contactUs: true, customerSuppport: false, footer: false, copyright: false, stylesheet: false },
        actions: [ ],
      },
      {
        countries: ['GB'],
        salesOrgs: ['GB47'],
        disable: { favIcon: false, pageTitle: false, logo: false, myText: false, myCompanyWebsite: false, contactUs: true, customerSuppport: false, footer: false, copyright: false, stylesheet: false },
        actions: [ ],
      },
      {
        countries: ['GB'],
        salesOrgs: ['GB49'],
        disable: { favIcon: false, pageTitle: false, logo: false, myText: false, myCompanyWebsite: false, contactUs: true, customerSuppport: false, footer: false, copyright: false, stylesheet: false },
        actions: [ ],
      },
      {
        disable: { favIcon: false, pageTitle: false, logo: false, myText: false, myCompanyWebsite: false, contactUs: false, customerSuppport: false, footer: false, copyright: false, stylesheet: false },
      }
    ])

    this.$store.dispatch('getUser').then(() => {
      this.$i18n.loadLanguageAsync(this.user.cultureCode)
    })

    this.$axios.get('/api/v1/navigation/left').then(success => {
      self.navItems = success.data
    })

    this.$axios.get('/api/v1/user/contactus').then(success => {
      self.contactUsUrl = success.data
    })

    this.$axios.get('/api/v1/user/facebook').then(success => {
      self.facebookUrl = success.data
    })

    this.$axios.get('/api/v1/user/twitter').then(success => {
      self.twitterUrl = success.data
    })

    this.$axios.get('/api/v1/user/youtube').then(success => {
      self.youtubeUrl = success.data
    })

    this.$axios.get('/api/v1/user/linkedin').then(success => {
      self.linkedinUrl = success.data
    })

    this.$axios.get('/api/v1/user/legalnotice').then(success => {
      self.legalnoticeUrl = success.data
    })

    this.$axios.get('/api/v1/user/privacypolicy').then(success => {
      self.privacypolicyUrl = success.data
    })

    this.$axios.get('/api/v1/user/support').then(success => {
      self.customerSupportUrl = success.data
    })

    this.$store.dispatch('getShipTos')
    this.$store.dispatch('getApplications')
    this.$store.dispatch('getRevalidationStatus')
  },
  updated() {
    const country = window.apci.getCookieByName('Country');
    const salesOrg = window.apci.getCookieByName('SalesOrg');
    const env =  window.apci.getEnvironmentPrefix();
    const localeId =  window.apci.getCookieByName('LocaleId');

    var options = window.apci.determineReplacementOptions([
      {
        countries: ['GB'],
        salesOrgs: ['GB46'],
        actions: [
          { action: 'remove', selector: '#ap-top-bar > div.left > a#osvc_reg_contactus' },
          { action: 'replace', selector: '#ap-top-bar > div.left > a', property: 'href', value: 'https://portal.airproducts.com/' },
          { action: 'replace', selector: '#ap-top-bar > div.left > a#osvc_reg_customerSupport', property: 'href', value: 'https://gasdirect.co.uk/customer-support' },
          { action: 'remove', selector: '#need-help' },
        ],
      },
      {
        countries: ['GB'],
        salesOrgs: ['GB47'],
        actions: [
          { action: 'remove', selector: '#ap-top-bar > div.left > a#osvc_reg_contactus' },
          { action: 'replace', selector: '#ap-top-bar > div.left > a', property: 'href', value: 'https://portal.airproducts.com/' },
          { action: 'replace', selector: '#ap-top-bar > div.left > a#osvc_reg_customerSupport', property: 'href', value: 'https://gasdirect.co.uk/customer-support' },
          { action: 'remove', selector: '#need-help' },
        ],
      },
      {
        countries: ['GB'],
        salesOrgs: ['GB49'],
        actions: [
          { action: 'remove', selector: '#ap-top-bar > div.left > a#osvc_reg_contactus' },
          { action: 'replace', selector: '#ap-top-bar > div.left > a', property: 'href', value: 'https://portal.airproducts.com/' },
          { action: 'replace', selector: '#ap-top-bar > div.left > a#osvc_reg_customerSupport', property: 'href', value: 'https://gasdirect.co.uk/customer-support' },
          { action: 'remove', selector: '#need-help' },
        ],
      }
    ],
    country,
    salesOrg);

    options.selectorOverrides = options.selectorOverrides || {};
    window.apci.performReplacements(options);
    window.apci.changeFooter(country, salesOrg, options);
    window.apci.changeContactUs(country, env, options, localeId);
    window.apci.changeCustomerSupport(country, env, options, localeId, salesOrg);
  },
  created() {
    var containerId = window.__env.gtmContainerId
    this.enableGTM(window, document, 'script', 'dataLayer', containerId)
  },
  methods: {
    enableGTM(w, d, s, l, i) {
      w[l] = w[l] || []
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l !== 'dataLayer' ? '&l=' + l : ''
      j.async = true
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
      f.parentNode.insertBefore(j, f)
    }
  }
}
</script>
